import { render, staticRenderFns } from "./MakeVsBuyROITable.vue?vue&type=template&id=b66493fc&scoped=true&"
import script from "./MakeVsBuyROITable.vue?vue&type=script&lang=js&"
export * from "./MakeVsBuyROITable.vue?vue&type=script&lang=js&"
import style0 from "./MakeVsBuyROITable.vue?vue&type=style&index=0&id=b66493fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66493fc",
  null
  
)

export default component.exports